<div class="w-full h-full">
  <p-scrollPanel [style]="{ width: '100%', height: '100%' }">
    <div class="integrations-container p-6">
      <div class="mb-6">
        <h1 class="text-3xl mb-4 underline">Integrations</h1>
      </div>

      <div class="integrations-grid grid grid-cols-1 lg:grid-cols-3 gap-6">
        <section>
          <fieldset class="integration-group-fieldset">
            <legend class="text-lg">SLB DrillPlan - Beta</legend>
            <div class="flex flex-col gap-4">
              <p-card>
                <ng-template pTemplate="header">
                  <div class="flex items-center gap-2 p-4 pb-0">
                    <i class="pi pi-link text-2xl text-primary"></i>
                  </div>
                </ng-template>
              <p class="text-sm text-gray-600 dark:text-gray-300">
                Import supported design inputs from SLB DrillPlan.
              </p>
              <ng-template pTemplate="footer">
                <div class="flex justify-end gap-2 p-3">
                  <p-button
                    label="Import"
                    icon="pi pi-download"
                    class="outlined-button"
                    severity="success"
                    outlined="true"
                    size="small"
                    (onClick)="showDrillPlanImportDialog.set(true)">
                  </p-button>
                </div>
              </ng-template>
              </p-card>
            </div>
          </fieldset>
        </section>

        <section>
          <fieldset class="integration-group-fieldset">
            <legend class="text-lg">WellCat EDM XML - Beta</legend>
            <div class="flex flex-col gap-4">
              <p-card>
                <ng-template pTemplate="header">
                  <div class="flex items-center gap-2 p-4 pb-0">
                    <i class="pi pi-file-import text-2xl text-primary"></i>
                  </div>
                </ng-template>
              <p class="text-sm text-gray-600 dark:text-gray-300">
                Upload an EDM XML export from WellCat and import supported design inputs.
              </p>
              <ng-template pTemplate="footer">
                <div class="flex justify-end gap-2 p-3">
                  <p-button
                    label="Import"
                    icon="pi pi-upload"
                    class="outlined-button"
                    severity="success"
                    outlined="true"
                    size="small"
                    (onClick)="showWellCatImportDialog.set(true)">
                  </p-button>
                </div>
              </ng-template>
              </p-card>
            </div>
          </fieldset>
        </section>
      </div>
    </div>
  </p-scrollPanel>
</div>

<app-drill-plan-import
  [visible]="showDrillPlanImportDialog()"
  (visibleChange)="showDrillPlanImportDialog.set($event)"
  (importComplete)="onImportComplete($event)">
</app-drill-plan-import>

<app-well-cat-import
  [visible]="showWellCatImportDialog()"
  (visibleChange)="showWellCatImportDialog.set($event)"
  (importComplete)="onWellCatImportComplete($event)">
</app-well-cat-import>
